import Form from 'react-bootstrap/Form';
import { useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import axios from 'axios';
import logo from "../media/TCOpfingen_Logo.png";
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../provider/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../App.js';

function Login() {
    const { login, user} = useAuth();
    const [values, setValues] = useState({ email: "", password: "" });
    const [forgotPassword, setForgotPassword] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);
    const navigate = useNavigate()
    

    if(user) {
        navigate("/booking")
    }

    const handleLogin = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        try {
            await login(values.email, values.password);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReset = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        const formData = { email: values.email };
        try {
            await axios.post(`${API_BASE_URL}/api/password-reset`, formData);
            toast.success("Email versendet. Überprüfe auf neue Nachrichten")
            setForgotPassword(false)
        } catch (error) {
            toast.error(error.response?.data?.message || "Fehler beim Passwort zurücksetzen")
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
    };
    
    const handleBlur = () => {
        // Kurz warten – wenn Fokus nur zu einem anderen Feld im Formular wechselt, nicht runterschieben
        setTimeout(() => {
            if (!formRef.current?.contains(document.activeElement)) {
                setIsFocused(false);
            }
        }, 0);
    };

    return (
        <Box 
            sx={{
                bgcolor: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                width: '100%',
                maxWidth: 450,
                position: 'fixed',
                top: isFocused ? '25%' : '50%',
                left: '50%',
                transform: isFocused ? 'translate(-50%, 0)' : 'translate(-50%, -50%)',
                transition: 'all 0.3s ease-in-out',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                overflow: 'hidden'
            }}
        >
            <div className='w-100 pt-3'>
                <img className="login-header-logo" src={logo} alt="logo" />
            </div>
            <div className='p-4'>
                <div>
                    {!forgotPassword ? (
                        <Form ref={formRef} onSubmit={handleLogin} className='text-center' onFocus={handleFocus} onBlur={handleBlur}>
                            <div className='d-flex justify-content-center align-items-center textfield'>
                                <div>
                                    <Form.Group className="mb-4" controlId="formGroupEmail">
                                        <TextField
                                            id="email"
                                            label="Email"
                                            autoComplete="email"
                                            size="small"
                                            variant="outlined"
                                            className='bg-white-25 rounded'
                                            sx={{ width: '310px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: 'primary.main' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: 'primary.main' } } }}
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-4" controlId="formGroupPassword">
                                        <TextField
                                            id="password"
                                            label="Passwort"
                                            variant="outlined"
                                            size="small"
                                            type="password"
                                            autoComplete="current-password"
                                            sx={{ width: '310px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: 'primary.main' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: 'primary.main' } } }}
                                            className='bg-white-25 rounded'
                                            onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                            <div className='text-center mt-3'>
                                <Button 
                                    variant="contained" 
                                    color="error" 
                                    type="submit" 
                                    sx={{ px: 4, py: 1 }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Anmelden..." : "Anmelden"}
                                </Button>
                            </div>
                            <p className='text-center mt-4 forgot-password mb-0' onClick={() => setForgotPassword(true)}>Passwort vergessen?</p>
                        </Form>
                    ) : (
                        <Form ref={formRef} onSubmit={handleReset} className='text-center text-field' onFocus={handleFocus} onBlur={handleBlur}>
                            <div className='d-flex justify-content-center align-items-center textfield'>
                                <Form.Group className="my-3" controlId="formGroupEmail">
                                    <TextField
                                        id="email"
                                        label="Email"
                                        autoComplete="email"
                                        size="small"
                                        variant="outlined"
                                        className='bg-white-25 rounded'
                                        sx={{ width: '310px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: 'primary.main' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: 'primary.main' } } }}
                                        onChange={e => setValues({ ...values, [e.target.id]: e.target.value })}
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className='text-center'>
                                <Button 
                                    variant="contained" 
                                    color="error" 
                                    type="submit" 
                                    sx={{ px: 4, py: 1 }}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Zurücksetzen..." : "Passwort zurücksetzen"}
                                </Button>
                            </div>
                            <p className='text-center mt-4 forgot-password mb-0' onClick={() => setForgotPassword(false)}>Zurück zum Login</p>
                        </Form>
                    )}
                </div>
            </div>
        </Box>
    );
}

export default Login;
